import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { StoreNames } from '@ho/shared/constants/store-config.enum';
export function createInitialState() {
    return { tabs: {} };
}
let GridStateStore = class GridStateStore extends Store {
    constructor() {
        super(createInitialState());
    }
};
GridStateStore.ctorParameters = () => [];
GridStateStore = __decorate([
    Injectable(),
    StoreConfig({ name: StoreNames.GridState }),
    __metadata("design:paramtypes", [])
], GridStateStore);
export { GridStateStore };
